
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedClosed as ObiThreewayStackedClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-closed.js';
 
 
 

 
 export const ObiThreewayStackedClosed = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-closed',
   elementClass: ObiThreewayStackedClosedElement,
   events: {
     
   }
  });
 
 